const resources = {
    giftFinder: 'Explorateur cadeaux',
    newChat: 'Nouvelle conversation',
    newChatSeparator: ' : '
};

export default function getResource(label) {
    return resources[label];
}
